module.exports = __webpack_public_path__ + "/dist/Exo2-Light.svg";